import { forwardRef } from "react";
import { Listen } from "./Audio";
import ui from "./ui.module.css";

// A tappable picture card. An item's own sound gets its Listen button beside
// the card, never inside it, so hearing a word never also chooses it.
const ItemCard = forwardRef(({ item, className, children, ...button }, ref) => {
  const card = (
    <button ref={ref} type="button" className={className} {...button}>
      {children}
    </button>
  );
  if (!item?.audio) return card;
  return (
    <div className={ui.cardWrap}>
      {card}
      <Listen audio={item.audio} label={item.label} small />
    </div>
  );
});

export default ItemCard;
